const { fetchAuthorizedJsonApi } = require('./abstract');
const { getApiLanguage } = require('./language');
const { getPlatform, getProvider } = require('./platform');
const { REWARDED_VIDEO_LOOTPACK_PLATFORMS } = require('../constants');

/**
 * @return Promise that returns the user's cards when fullyfilled.
 */
function fetchCards(apiUrl, token, sliceParams = {}, country) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'GET',
    endpoint: 'v5/cards',
    query: {
      lang: getApiLanguage(),
      country,
      platform: getPlatform(),
      rewardedVideoLootpack: REWARDED_VIDEO_LOOTPACK_PLATFORMS[getProvider()],
      ...sliceParams,
    },
    expectedStatus: 200,
    description: 'Fetching cards',
  });
}

function fetchCard(apiUrl, token, cardId, country) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'GET',
    endpoint: `v1/cards/${cardId}`,
    query: {
      lang: getApiLanguage(),
      country,
      platform: getPlatform(),
      rewardedVideoLootpack: REWARDED_VIDEO_LOOTPACK_PLATFORMS[getProvider()],
    },
    expectedStatus: 200,
    description: 'Fetching card',
  });
}

function getReward(apiUrl, token, cardId) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'GET',
    endpoint: `v1/cards/${cardId}/reward`,
    query: { lang: getApiLanguage() },
    expectedStatus: 200,
    description: "Getting the card's reward",
  });
}

function shredCard(apiUrl, token, cardId) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'PUT',
    endpoint: `v1/cards/${cardId}/shred`,
    query: { lang: getApiLanguage() },
    expectedStatus: 200,
    description: 'Shredding card',
  });
}

function shredCards(apiUrl, token, cardsIds) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'PUT',
    endpoint: 'v1/cards/shred',
    query: { lang: getApiLanguage() },
    body: cardsIds,
    expectedStatus: 200,
    description: 'Shredding cards',
  });
}

function sendQuestSolution(apiUrl, token, cardId, data, files, country) {
  const formData = new FormData();
  formData.append('data', JSON.stringify(data));
  files.forEach((element) => formData.append(element.index, element.value));
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'PUT',
    endpoint: `v1/cards/${cardId}/solution`,
    query: {
      lang: getApiLanguage(),
      country,
      platform: getPlatform(),
      rewardedVideoLootpack: REWARDED_VIDEO_LOOTPACK_PLATFORMS[getProvider()],
    },
    headers: { 'Content-Type': null },
    body: formData,
    expectedStatus: 200,
    description: 'Sending quest solution',
  });
}

function sendShareLink(apiUrl, token, cardId, postUrl) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'PUT',
    endpoint: `v1/cards/${cardId}/share`,
    query: { lang: getApiLanguage() },
    body: postUrl,
    expectedStatus: 204,
    description: 'Sending post link',
  });
}

module.exports = {
  fetchCards,
  fetchCard,
  getReward,
  shredCard,
  shredCards,
  sendQuestSolution,
  sendShareLink,
};
